/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-14 20:38:17
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-02 17:34:14
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/Subscription/index.tsx
 */
import React from 'react';
//import css from './css.module.less';
import { ContentModuleGroupPreloadingContext } from 'src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import _Sub from 'src/components/Modules/Subscription';
//import _ResponsiveSub from 'src/components/Modules/ResponsiveSubscription';
import ContentGroupHOC from '../HOC';
import { compose } from 'redux';
import DataHOC from 'src/constrains/DraggableModules/Components/HOC/DataProcessHOC';
//import { WebSiteSubType } from 'src/types/common/SalesChannel';
import { EnumFieldType } from 'src/types/common/customerDb';

const Subscription = (props) => {
  const {
    staticData,
    dynamicData,
    handleOnItemDelete,
    handleItemOnAdd,
    handleItemOnChange,
    handleItemOnSort,
    handleOnItemDeleteAll,
    handleOnReselect,
    handleOnStaticsChange,
    specificError,
    droppableId,
    draggableId,
    //extraProps,
    //linkSet,
  } = props || {};
  //const { siteStyle, breakpoint } = extraProps || {};

  const {
    tc,
    fields: customerFields,
    // buttons,
    // animations,
  } = React.useContext(ContentModuleGroupPreloadingContext);
  const { fields, tacs } = dynamicData;
  const _f = (customerFields || []).filter(
    (i) => i.fieldType !== EnumFieldType.AreaCodeMobileNumber,
  );
  const renderBody = () => {
    return (
      <_Sub
        tcsOptions={tc}
        specificError={specificError}
        fields={fields}
        tacs={tacs}
        fieldsOptions={_f}
        draggableId={draggableId}
        staticData={staticData}
        droppableId={droppableId}
        onItemDelete={handleOnItemDelete}
        onItemAdd={handleItemOnAdd}
        onItemChange={handleItemOnChange}
        onItemSort={handleItemOnSort}
        onStaticChange={handleOnStaticsChange}
        onItemDeleteAll={handleOnItemDeleteAll}
        onItemReselect={handleOnReselect}
      />
    );
  };

  return renderBody();
};
export default compose(DataHOC, ContentGroupHOC)(Subscription);
